<template>
<svg ref="art" aria-hidden="true" width="1280" height="720" viewBox="0 0 1280 720" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">

<g id="MS______________________________________8___" clip-path="url(#clip0_1515_3978)">


<g id="______________________1" transform="translate(380 312)">
<mask id="mask0_1515_3978" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="720">
<g id="Brand_mark">
<g clip-path="url(#clip5_1515_3978)">
<rect id="MS_1_2" width="96" height="96" fill="url(#pattern0_1515_3978)"/>
</g>
</g>
</mask>
<g mask="url(#mask0_1515_3978)">
<rect id="Rectangle" x="0.4" y="0.4" width="95.2" height="95.2" fill="#B631EF" fill-opacity="0.65" stroke="#B631EF" stroke-width="0.8"/>
</g>
</g>
<g id="______________________2" transform="translate(380 312)">
<mask id="mask1_1515_3978" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="720">
<g id="Brand_mark_2">
<g clip-path="url(#clip6_1515_3978)">
<rect id="MS_1_2_2" width="96" height="96" fill="url(#pattern1_1515_3978)"/>
</g>
</g>
</mask>
<g mask="url(#mask1_1515_3978)">
<rect id="Rectangle_2" x="0.4" y="0.4" width="95.2" height="95.2" fill="#5D36F1" fill-opacity="0.65" stroke="#5D36F1" stroke-width="0.8"/>
</g>
</g>
<g id="______________________3" transform="translate(380 312)">
<mask id="mask2_1515_3978" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="720">
<g id="Brand_mark_3">
<g clip-path="url(#clip7_1515_3978)">
<rect id="MS_1_2_3" width="96" height="96" fill="url(#pattern2_1515_3978)"/>
</g>
</g>
</mask>
<g mask="url(#mask2_1515_3978)">
<rect id="Rectangle_3" x="0.4" y="0.4" width="95.2" height="95.2" fill="#2567FF" fill-opacity="0.65" stroke="#2567FF" stroke-width="0.8"/>
</g>
</g>
<g id="______________________4" transform="translate(380 312)">
<mask id="mask3_1515_3978" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="720">
<g id="Brand_mark_4">
<g clip-path="url(#clip8_1515_3978)">
<rect id="MS_1_2_4" width="96" height="96" fill="url(#pattern3_1515_3978)"/>
</g>
</g>
</mask>
<g mask="url(#mask3_1515_3978)">
<rect id="Rectangle_4" x="0.4" y="0.4" width="95.2" height="95.2" fill="#00A6C5" fill-opacity="0.65" stroke="#00A6C5" stroke-width="0.8"/>
</g>
</g>
<g id="______________________5" transform="translate(380 312)">
<mask id="mask4_1515_3978" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="720">
<g id="Brand_mark_5">
<g clip-path="url(#clip9_1515_3978)">
<rect id="MS_1_2_5" width="96" height="96" fill="url(#pattern4_1515_3978)"/>
</g>
</g>
</mask>
<g mask="url(#mask4_1515_3978)">
<rect id="Rectangle_5" x="0.4" y="0.4" width="95.2" height="95.2" fill="#14C783" fill-opacity="0.65" stroke="#14C783" stroke-width="0.8"/>
</g>
</g>
<g id="______________________6" transform="translate(380 312)">
<mask id="mask5_1515_3978" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="720">
<g id="Brand_mark_6">
<g clip-path="url(#clip10_1515_3978)">
<rect id="MS_1_2_6" width="96" height="96" fill="url(#pattern5_1515_3978)"/>
</g>
</g>
</mask>
<g mask="url(#mask5_1515_3978)">
<rect id="Rectangle_6" x="0.4" y="0.4" width="95.2" height="95.2" fill="#E6C23B" fill-opacity="0.65" stroke="#E6C23B" stroke-width="0.8"/>
</g>
</g>
<g id="______________________7" transform="translate(380 312)">
<mask id="mask6_1515_3978" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="720">
<g id="Brand_mark_7">
<g clip-path="url(#clip11_1515_3978)">
<rect id="MS_1_2_7" width="96" height="96" fill="url(#pattern6_1515_3978)"/>
</g>
</g>
</mask>
<g mask="url(#mask6_1515_3978)">
<rect id="Rectangle_7" x="0.4" y="0.4" width="95.2" height="95.2" fill="#FF5B2B" fill-opacity="0.65" stroke="#FF5B2B" stroke-width="0.8"/>
</g>
</g>
<g id="MS_________________MarkSimos_______" clip-path="url(#clip12_1515_3978)" transform="translate(380 312)">
<g id="Marksimos_brand" clip-path="url(#clip13_1515_3978)">
<g id="Brand_mark_8">
<g clip-path="url(#clip14_1515_3978)">
<rect id="MS_1_2_8" width="96" height="96" fill="url(#pattern7_1515_3978)"/>
</g>
</g>
<rect id="MS_2_2" transform="translate(126 6.97252)" width="393" height="82.0549" fill="url(#pattern8_1515_3978)"/>
</g>
</g>
<g id="______________________________" clip-path="url(#clip15_1515_3978)" transform="translate(380 312)">
<mask id="mask7_1515_3978" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="1280" height="720">
<g id="Marksimos_brand_2" clip-path="url(#clip16_1515_3978)">
<g id="Marksimos_brand_3" clip-path="url(#clip17_1515_3978)">
<g id="Brand_mark_9">
<g clip-path="url(#clip18_1515_3978)">
<rect id="MS_1_2_9" width="96" height="96" fill="url(#pattern9_1515_3978)"/>
</g>
</g>
<rect id="MS_2_2_2" transform="translate(126 6.97247)" width="393" height="82.0549" fill="url(#pattern10_1515_3978)"/>
</g>
</g>
</mask>
<g mask="url(#mask7_1515_3978)">
<g id="____________" filter="url(#filter0_f_1515_3978)" transform="translate(-100 -32) rotate(12)">
<rect width="88" height="160" id="_____________bg_0" fill="white" fill-opacity="0.7">
</rect>
</g>
</g>
</g>
</g>
<defs>
<pattern id="pattern0_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern1_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern2_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern3_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern4_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern5_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern6_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern7_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern8_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image1_1515_3978" transform="scale(0.00156986 0.0075188)"/>
</pattern>
<pattern id="pattern9_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_1515_3978" transform="translate(-0.0010661) scale(0.0021322)"/>
</pattern>
<pattern id="pattern10_1515_3978" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image1_1515_3978" transform="scale(0.00156986 0.0075188)"/>
</pattern>
<filter id="filter0_f_1515_3978" x="-49.1435" y="-34.5013" width="186.287" height="229.002" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_1515_3978"/>
</filter>
<radialGradient id="paint0_radial_1515_3978" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(444.444 222) scale(444.444 222)">
<stop stop-color="#DDEEFF" stop-opacity="0.8"/>
<stop offset="1" stop-color="#F8FAFC" stop-opacity="0"/>
</radialGradient>
<radialGradient id="paint1_radial_1515_3978" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(577.778 252) scale(577.778 252)">
<stop stop-color="#DDEEFF" stop-opacity="0.8"/>
<stop offset="1" stop-color="#F8FAFC" stop-opacity="0"/>
</radialGradient>
<clipPath id="clip0_1515_3978">
<rect width="1280" height="720" fill="white"/>
</clipPath>
<clipPath id="clip1_1515_3978">
<rect width="1280" height="1066.67" fill="white"/>
</clipPath>
<clipPath id="clip2_1515_3978">
<rect width="1280" height="720" fill="white"/>
</clipPath>
<clipPath id="clip3_1515_3978">
<rect width="373.333" height="207.932" fill="white"/>
</clipPath>
<clipPath id="clip4_1515_3978">
<rect width="579.556" height="579.556" fill="white"/>
</clipPath>
<clipPath id="clip5_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<clipPath id="clip6_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<clipPath id="clip7_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<clipPath id="clip8_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<clipPath id="clip9_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<clipPath id="clip10_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<clipPath id="clip11_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<clipPath id="clip12_1515_3978">
<rect width="519" height="96" fill="white"/>
</clipPath>
<clipPath id="clip13_1515_3978">
<rect width="519" height="96" fill="white"/>
</clipPath>
<clipPath id="clip14_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<clipPath id="clip15_1515_3978">
<rect width="519" height="96" fill="white"/>
</clipPath>
<clipPath id="clip16_1515_3978">
<rect width="519" height="96" fill="white"/>
</clipPath>
<clipPath id="clip17_1515_3978">
<rect width="519" height="96" fill="white"/>
</clipPath>
<clipPath id="clip18_1515_3978">
<rect width="96" height="96" rx="18" fill="white"/>
</clipPath>
<image id="image0_1515_3978" data-name="MS_1.png" width="470" height="469" preserveAspectRatio="none" xlink:href="data:image/png;base64,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"/>
<image id="image1_1515_3978" data-name="MS_2.png" width="637" height="133" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAn0AAACFCAYAAAAuLU6QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKTWlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVN3WJP3Fj7f92UPVkLY8LGXbIEAIiOsCMgQWaIQkgBhhBASQMWFiApWFBURnEhVxILVCkidiOKgKLhnQYqIWotVXDjuH9yntX167+3t+9f7vOec5/zOec8PgBESJpHmomoAOVKFPDrYH49PSMTJvYACFUjgBCAQ5svCZwXFAADwA3l4fnSwP/wBr28AAgBw1S4kEsfh/4O6UCZXACCRAOAiEucLAZBSAMguVMgUAMgYALBTs2QKAJQAAGx5fEIiAKoNAOz0ST4FANipk9wXANiiHKkIAI0BAJkoRyQCQLsAYFWBUiwCwMIAoKxAIi4EwK4BgFm2MkcCgL0FAHaOWJAPQGAAgJlCLMwAIDgCAEMeE80DIEwDoDDSv+CpX3CFuEgBAMDLlc2XS9IzFLiV0Bp38vDg4iHiwmyxQmEXKRBmCeQinJebIxNI5wNMzgwAABr50cH+OD+Q5+bk4eZm52zv9MWi/mvwbyI+IfHf/ryMAgQAEE7P79pf5eXWA3DHAbB1v2upWwDaVgBo3/ldM9sJoFoK0Hr5i3k4/EAenqFQyDwdHAoLC+0lYqG9MOOLPv8z4W/gi372/EAe/tt68ABxmkCZrcCjg/1xYW52rlKO58sEQjFu9+cj/seFf/2OKdHiNLFcLBWK8ViJuFAiTcd5uVKRRCHJleIS6X8y8R+W/QmTdw0ArIZPwE62B7XLbMB+7gECiw5Y0nYAQH7zLYwaC5EAEGc0Mnn3AACTv/mPQCsBAM2XpOMAALzoGFyolBdMxggAAESggSqwQQcMwRSswA6cwR28wBcCYQZEQAwkwDwQQgbkgBwKoRiWQRlUwDrYBLWwAxqgEZrhELTBMTgN5+ASXIHrcBcGYBiewhi8hgkEQcgIE2EhOogRYo7YIs4IF5mOBCJhSDSSgKQg6YgUUSLFyHKkAqlCapFdSCPyLXIUOY1cQPqQ28ggMor8irxHMZSBslED1AJ1QLmoHxqKxqBz0XQ0D12AlqJr0Rq0Hj2AtqKn0UvodXQAfYqOY4DRMQ5mjNlhXIyHRWCJWBomxxZj5Vg1Vo81Yx1YN3YVG8CeYe8IJAKLgBPsCF6EEMJsgpCQR1hMWEOoJewjtBK6CFcJg4Qxwicik6hPtCV6EvnEeGI6sZBYRqwm7iEeIZ4lXicOE1+TSCQOyZLkTgohJZAySQtJa0jbSC2kU6Q+0hBpnEwm65Btyd7kCLKArCCXkbeQD5BPkvvJw+S3FDrFiOJMCaIkUqSUEko1ZT/lBKWfMkKZoKpRzame1AiqiDqfWkltoHZQL1OHqRM0dZolzZsWQ8ukLaPV0JppZ2n3aC/pdLoJ3YMeRZfQl9Jr6Afp5+mD9HcMDYYNg8dIYigZaxl7GacYtxkvmUymBdOXmchUMNcyG5lnmA+Yb1VYKvYqfBWRyhKVOpVWlX6V56pUVXNVP9V5qgtUq1UPq15WfaZGVbNQ46kJ1Bar1akdVbupNq7OUndSj1DPUV+jvl/9gvpjDbKGhUaghkijVGO3xhmNIRbGMmXxWELWclYD6yxrmE1iW7L57Ex2Bfsbdi97TFNDc6pmrGaRZp3mcc0BDsax4PA52ZxKziHODc57LQMtPy2x1mqtZq1+rTfaetq+2mLtcu0W7eva73VwnUCdLJ31Om0693UJuja6UbqFutt1z+o+02PreekJ9cr1Dund0Uf1bfSj9Rfq79bv0R83MDQINpAZbDE4Y/DMkGPoa5hpuNHwhOGoEctoupHEaKPRSaMnuCbuh2fjNXgXPmasbxxirDTeZdxrPGFiaTLbpMSkxeS+Kc2Ua5pmutG003TMzMgs3KzYrMnsjjnVnGueYb7ZvNv8jYWlRZzFSos2i8eW2pZ8ywWWTZb3rJhWPlZ5VvVW16xJ1lzrLOtt1ldsUBtXmwybOpvLtqitm63Edptt3xTiFI8p0in1U27aMez87ArsmuwG7Tn2YfYl9m32zx3MHBId1jt0O3xydHXMdmxwvOuk4TTDqcSpw+lXZxtnoXOd8zUXpkuQyxKXdpcXU22niqdun3rLleUa7rrStdP1o5u7m9yt2W3U3cw9xX2r+00umxvJXcM970H08PdY4nHM452nm6fC85DnL152Xlle+70eT7OcJp7WMG3I28Rb4L3Le2A6Pj1l+s7pAz7GPgKfep+Hvqa+It89viN+1n6Zfgf8nvs7+sv9j/i/4XnyFvFOBWABwQHlAb2BGoGzA2sDHwSZBKUHNQWNBbsGLww+FUIMCQ1ZH3KTb8AX8hv5YzPcZyya0RXKCJ0VWhv6MMwmTB7WEY6GzwjfEH5vpvlM6cy2CIjgR2yIuB9pGZkX+X0UKSoyqi7qUbRTdHF09yzWrORZ+2e9jvGPqYy5O9tqtnJ2Z6xqbFJsY+ybuIC4qriBeIf4RfGXEnQTJAntieTE2MQ9ieNzAudsmjOc5JpUlnRjruXcorkX5unOy553PFk1WZB8OIWYEpeyP+WDIEJQLxhP5aduTR0T8oSbhU9FvqKNolGxt7hKPJLmnVaV9jjdO31D+miGT0Z1xjMJT1IreZEZkrkj801WRNberM/ZcdktOZSclJyjUg1plrQr1zC3KLdPZisrkw3keeZtyhuTh8r35CP5c/PbFWyFTNGjtFKuUA4WTC+oK3hbGFt4uEi9SFrUM99m/ur5IwuCFny9kLBQuLCz2Lh4WfHgIr9FuxYji1MXdy4xXVK6ZHhp8NJ9y2jLspb9UOJYUlXyannc8o5Sg9KlpUMrglc0lamUycturvRauWMVYZVkVe9ql9VbVn8qF5VfrHCsqK74sEa45uJXTl/VfPV5bdra3kq3yu3rSOuk626s91m/r0q9akHV0IbwDa0b8Y3lG19tSt50oXpq9Y7NtM3KzQM1YTXtW8y2rNvyoTaj9nqdf13LVv2tq7e+2Sba1r/dd3vzDoMdFTve75TsvLUreFdrvUV99W7S7oLdjxpiG7q/5n7duEd3T8Wej3ulewf2Re/ranRvbNyvv7+yCW1SNo0eSDpw5ZuAb9qb7Zp3tXBaKg7CQeXBJ9+mfHvjUOihzsPcw83fmX+39QjrSHkr0jq/dawto22gPaG97+iMo50dXh1Hvrf/fu8x42N1xzWPV56gnSg98fnkgpPjp2Snnp1OPz3Umdx590z8mWtdUV29Z0PPnj8XdO5Mt1/3yfPe549d8Lxw9CL3Ytslt0utPa49R35w/eFIr1tv62X3y+1XPK509E3rO9Hv03/6asDVc9f41y5dn3m978bsG7duJt0cuCW69fh29u0XdwruTNxdeo94r/y+2v3qB/oP6n+0/rFlwG3g+GDAYM/DWQ/vDgmHnv6U/9OH4dJHzEfVI0YjjY+dHx8bDRq98mTOk+GnsqcTz8p+Vv9563Or59/94vtLz1j82PAL+YvPv655qfNy76uprzrHI8cfvM55PfGm/K3O233vuO+638e9H5ko/ED+UPPR+mPHp9BP9z7nfP78L/eE8/sl0p8zAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAACDdSURBVHja7J3Pddu61sV3sjKXvgqsVwGUCsxUYN0KTE84jTLRNMqUkzDDh0noCi5TQegKQlZw5QqeXEG+AY6udX0lGaQIEqD2by0ux7FEAiD+bBwA57z5/fs3CCGEEEKIG9I0nQGI5JoBmAOYHPl4DWADoAJQrlarsqt0vKHoI4QQQghxIvQWAGIA6oxbPQEoAOTnCkCKPkIIIYSQbsXeGsDtiz89ACjl2qxWq82B705hrIC7KwJwtfeRRwDr1WqVU/QRQgghhAwj9qYi9j6+EHo5gGK1Wm1b3ncOYAljNZzsib+4qeWPoo8QQggh5DzBtxBxN9kTe+su9+OJqFzKtXvON3mOlaCk6COEEEIIaS/GMjxb91pZ4FqIv/XeM2t5ZkXRRwghhBDiRnwVAK7lvxpZ3Tp4fiTPn8Ac9li8JjYp+gghhBBCmgu+EuZU7hOAZdvDFR2mAwDuTqWDoo8QQgghpL3gi2yWVh2nJ8PzaeEPxyx+b/n6CCGEEEKsyXwRfACwWq22q9UqBnAv/1XIid9/QUsfIYQQQogFaZouAXyVXw9a1PZ87Z3DtqmYfGGBrEWQbin6CCGEEEKaiao5gF/y66fVapUd+VwE4GeHj36AObBRHHLofED4bWAOd3xbrVbL/b9zeZcQQggh5HV2Iu/hmOBzxDWMdfGvNE0zEXYHEcveQn79KAKUoo8QQgghxIY0TWMRX08wsXSH4iPMEi5OCL8Sz/v7Moo+QgghhBB71jsR9doSaw+oNE3Xr3xmKQJViWCl6COEEEIIOYWIpisRUZknyVpaLPNmewKQoo8QQggh5BVi+Zl1EG3jE4APJ647AF9glmcfT9xngue9e8fYiT61c+Hyju+SEEIIIeTfpGk6w3OYtayDW1ZN4vKmaZrj2enyS+anvrtarbZpmt7L95cAYlr6CCGEEEIOs5CfP/qKqfuC5Ym/zS2+X8jPCODyLiGEEELIa6KvGOLhIjQfzvh+AbMX8SpN0zlFHyGEEELIYXZLu+WAaZie+f1d2iOKPkIIIYSQF+zFr30cyk2LnNBVZ96mkp+09BFCCCGEHGAmP4cUfMWJj5SWt9p9bsbTu4QQQggh/2YuP6sO7xm/DI124tkRjGuWYxSWz9zu7knRRwghhBDyumjqgtuO7vO4Wq2sxOhqtarSNAWACZd3CSGEEELCIm7zJYo+QgghhJBwuGvi4JmijxBCCCEkLB4AvF+tVnnbG3BPHyGEEEKI37y33cP3EjkFTNFHCCGEEHKErfycd3jPD8eWZtM0jQF8P/K9JVru49tLf83lXUIIIYSQf1PJz1kfD5Nl22Mh124tXb0cYpf+LUUfIYQQQshx0ad6fOb6xN+ylvecy8+Soo8QQggh5AWr1WoL4BEA0jRd9PTMEsD9kT+rNE2XLW4b7UQsRR8hhBBCyGHKF8KpD9an/rZ/MOM10jSd4dlSSUsfIYQQQsgRCvm56OuBq9VqA+DLkT9P0GyZd5fuH6vVinv6CCGEEEKOCLACwBOAq76WeIVMnnuIJoc6lvvilaKPEEIIIeS0ANsXUH2IzS3OPNQhIvVKxCNFHyGEEELIK+Ty8/oMtylthF8GOUhyAJtDHTvRmImIpOgjhBBCCDkhvjZ4PlGb9fz4+JSoO3aoQxw9Kxgr399ppugjhBBCCDnNUgRUW7cpbQVnieMOmw8e6hAhuPv/v618FH2EEEIIIa+Lry2el0vXaZrOT3x8K0Lt0LVtKTiP3W8mbln2yUUQ1qvVar3/hze/f//m2ySE+IVSUxgv8jO5dr+/xkauLYw3/Q3qesMCJYR0QZqmJYBrADWAaN+K5kn6lgC+yq/vV6tVtf/3d3yFhBBPRN4CxgFqBHPirA3XB+79JAKwBFCgrisWOCGkJQuZWCrpU+a+JEz28e0E36eXgg8A3vz3v/9dA/h8xnOeAMySJNmO8e1qrcuDA4k9D0mSRGwno6sX1ibyJEnesMSOir0FzEblmx6f+gjjviBzYgVUKgLw01Hav6Cu16w4hAwqruYi+CYwBzyWQ1v8RPB9l1/vV6tVfOhzXezpm6BHT9U9D+yzMwUfIeSwMIqh1AbAnz0LPsBYET8C+AtK5VBqxhdCCLFFLGg73XMLoGwSGm0owdeV6ANOHykOmZjVm5BOxV4EpSrpoK48SNGtiL9MlpgJIcRG+JUAPkBO9AKoXjnc4UrwZbaCr0vRdy1WMYo+QsgxwbeGWfZUHqbuI4ASSs35ogghDYRfJMLvCsCvNE3XPYm9eZqmlfRdAPDtNcHXpegbnUDSWkfwwxJBSOhibwqlCpy3d7iXlFL4EUIaCr8KxsPAzpfe5zRNN64id6RpOkvTNAfwC8/Ol/9YrVZLm+9T9F1OfggZRvCZDc83gaR4QuFHCGko/Lar1SoC8AnPVr+faZqWst+uC7E3F7H3F8y2FAD4AWC2Wq0K2/t06bLlSmsdJUlShv4CtdZTjPRwCiE9U8DP5Vw74Ucff4QQe/GXiTBbynUNE683k76wAFDanvQVa2EkemS/H30AsJbl5UZ07acvlll96Cyk4yeEtEWpDOGefp/AeLWP+CIJIQ2E3xYmYkcmwi+GsfzdyoU0TR9hfP1V+HeEjjmMM/pDfec9gLyN2HMl+hZa6+kIfPbFrLqEnCX4IjxvMA6VaygVo65zvlBCSBvxh+eQbbFMIpWIwCuLSfEjjCGtBFB04Quwa9G389kXbCdJ33yEdMJYhFIGpQrU9ZavlBDSUgBWMFY/AH8v2wKHVxI2clUuHD67CMMWB97hx6yihJyBcc0ylpPvE+kTMr5YQkhHIrCUf5Z9P/utg3uG7rOPoo+Q9oJvuj+jHQlLvlhCyBh46+i+QQon+uYj5GwWGN8hqCvZo0gIIRR9YxF9oJWPkHNZjljMEkIIRd+hmbFYzYJBfPPdskoQ0hKlZnDvk68GcAfgPer6DYD/A/AHjJNSij5CCOlQ9NUw3qZtiEc8k69ZdQjpXRh9Ql3PUdc56royLbHeoq4L1PVCxKArrkTUEkJIsDQ9vbuF8ShtYxELzWff0vJzjwgzygAhIYu+b6jr7PRUrM5FmLmK8TuHcaVg008+OErDhtWMENKX6AOMOxYb0ReMzz45bWwr4gpWG0KOiiIXPKKubSdlmUzgJo7y93r7N1bIiNWBEOIbjff0SWzdR8uPx4GUw7LBZzNWG0JeoNQc7k7t2rc540TZ1USTQo4QEjRtnTPnsFtCudZaz5Ik2XheDgvbISVJko3WmjWHkH8ydXjvokX/9JGvZPCJwAzA7IRAL3tKxymxXgUTbeW18hyibN1PJG36lQ3qesMG54foA4y1b+1rAWitF7D3zZexyhBykMjRfZ8ad+h1XUE52XLL8Iyvi5KFXNcWnwfMqlElwr6bcHdKxVIfI6u+XaknSUMpaag8KMtd+udyXTX8/t+tARLSC0DppRg0Dt1f5nfSIr+PktdyL79bNswORJ9Yux4sO0GvRR+abT4vWGUI6ZW2A7Bt/+RK/MSO7n564Hb37A3qOj8hUNYty3sXeP4GJs5xDmDdeLA2+V6jnXPwiaT9GsBnKPUgaSh7rjeLPdHc1VYJJdeN5O1pT2APN54ZoRfL1dUMbVeXrvee86PTCcWlij4ht2zkV1rrSPYCekVD33z3AZ1Etsl7tCfiSzaFg2WzTZKkYolYMXd032mAZTGDuxPEwOl4na6e/YCXeyXNwL1Gd0vpE7lXDKUWVqKr+zRAxrWfIhhi52LBWCbX6Cca1ETGvFso9SjiNu95QrRGfz5xb/YmFAWA5aWLv3NEXwGz3GkzI4kxQGBhCxYN8xuKaJnh2Uw+l4FzfuxdHdijWMO4ndhgz1w+MtE7xetLCg/g5v2hxZlfrpGUmnH/EHb7rXJH72ciouvupCBxm4adYCihVOREKLhP/2tcAfgOpdYibkuH9WUqemGoAAg7sbuAUhnqek3R15AkSbZa6wJh++xbWn7uMUkSr0Wf7E1cwHYfi91Au7PkfpZn1NJJFS4P52it57DcP5kkSdTw3rGU081YG3WT8js0QfPu4JVScy/2WRlmuHRfeUaslHAfY/k7lMJB4ddfGpQT4WeE1mdP3uiViOx7uLCEGUtmBj9ick9glrnNWHmBVr93Z34/R6A++8bgm0+sVUsYS2ofSwMKwFcAX7XWPwBkjpaGp+h4P5aI4qynchqyTsQAvrf8+p2nJ+0XaL63z5VIvLhB4sUAPpV+vK8BPINS5T+sqyYNZY9pUJLnRYfl5+Ok8xbAvFOBa/Zo+hjeVAHYSF6rS2rCZ4m+JElKrfWj5UAawy9HzctGHY+fYm854OzpBsCN1voewNLXpV8pqwIXcPLyDMH3BGPhKzzN2lKWZOzrmL0zZ9J8ot/ncuREnhm9mIT33e/dyD7D9m3kWaz6HM2pOzHkr+Dbr1ulrCRsLqUBv+2oE7DhWqxrPlkPrIYPn6wfYrHawCwN+GAuvwVQyZKibyIokrKi4Dst+CLPty9MEEBkn9FjTukOYaG6liVCQKnlgO05O6PsQhB8/2xvJs1jFXz7eS3OyitF30lij4RTcL75tNYZgD89EXv7XAEofRJ+IoJ+elhWPgq+KoBs3shAQoZjyPJf753UHa6f24nPdmUXUrx2hbbbmpTKAhF8+3ldX0ojPlv0iRXMNrh47Em+Fw0+W/iQYK11Dr+jDEx8EX5n7mu7FMFXA5h3KPg2PWT3Fkpd1KzcI64x7H7YK/S7j6+LsWMngpYI8+DYtaS9SV4jhBkN56McDqLo63gGeLXvH26gQXKKwHzzieALxVSeSxkPVVbRBQm+9RmCL+p428Kmp2zfAKheCa1FxokPlrKbRpOOZ790obJuOMnKg84rRZ81BcxSkQ1xQDO1woOBPQNN5bZlNceFRE2RiUAblw87wdf1ZGbTY/Z3LiZyGVQJ6ZN5g89mCHuLyQS2W5zM0nfI3hFuLqE/6UT0yQBiO9guhrQEISDffLL3sAtT+RPMEvw9gC9Hrnv5zFMHz/s40KGdHJexhy9vORG4T5Jk7sh6vRmgKG4B/EXxR3omshRBEcbhD/TW0tq3HkFeF2OvvO86vJftQDSYzz6xBKkG+RlyYJ/ivEMku5iDZdNlPCmnSARy25lb3GcnIEudauwN9kzBFztLWF2Xe0HehxB/txI2K/MyqDwZE7YTjOWI8rw82Z+b/XAurXw1zJ7OrZR/5Oh5MTxz0eat6AvEZ1+TQS/3oJG1qdTfYJwmb854lxWMc9tMa71r7E0taIu+RJ+I1HO82z/gOeTcFs+OfbcjEXzfkiTpYwB6wLDucUyczV1MUQZZJ0OJPmN5dmnl203qNzDO7BdyuVrpeG0S72pC+QATIm5zoIwjdO+zUUGp6Zj7jXcd3y+3HHyvtdazAfzf2VbMhyF98+05X246E1p0ne4kSTKtdSmNq4kIVT2G3stalFUBE06uCqGhniH47pIk6WsCU8APn4gmpuhzkPU14+USjw0Mjdv0gdB0hePQdFevhEOMnAjbul4c78XrUoTfr46fuytHir4ORZ/NzKHrQbPJLCgf+L00nbG52py/E36VlF/TDsV545F02QqNexgraBVKAz0zokifgm8n+r56VHy7IOu3UOoBQH4wjitpw6O07c3eoN+34H+SNFR7/U0E9/t6ZwOKvm9H63BdVxJT9qfDcelY3+lib8frhg+T53t0e9hx1KLvbZc389xnX9ygIyk8EH1NOr7ItUVNhNKy4deiHsoqs/jMA4D3SZLEAQq+ssVg+gTgj54FH8Sa9sPT4rwG8B1KbaHUmr7+zuIT6nqGuo5R12u5IgDvZQLaB/cAZqjrxV4aFiLIXNfB0yseZmnX1f627JU2WDp8B9GR/Lro5+sG1vmu+7lR9w1vHdzT9gX05rNPBk/b/RXFkL75GqYV6DHurYiIR8/q8Gud65ckSaKQxN4Lwdd0Bj10WLXM86KdwKxGbCj+WvENdZ0dERwV+jn9WIvg3B5Iw1bE35D9lKsyeLAUQq4me31acpuMaV337TOKvmYU8M9nX5Pn5AO/k3mTAb53a05YfvDukiRZh9YoOxB8wwlcY2n4EUAx74u/JbVcR6LeiJJ7DyYWQ7Z7V8aMciAR9MzhqBXDiqTuD11Q9DXBU599tqLvMUmScuB30qTDGEKghiL67gYQxEMKvhrAzBOL5hLd+HvsS/x9hVLVpYRhOmd4tbQ0ue4jCg/S0NXEvXvR59Zl0awnkXRNK7wb3jm6bw5PfPaF5JuvRQMaQqBuA6jXXwIVfDMZrNoIvsiHkIEy6OysZyGFw1MAfkGpT0eXL4ltf+Ny4lFbWXbqeiuue4aIEOHqmU3K1VXe5z0K6hy2S+V1/YbN0w4Xy7sQa5ntnorYcR7jhpUsJNFX9Z24APbGPQS6pDuX99lU8D14JfieO+Ec7pf5XPBVInzQytB2wufWPU6Ter7pvYRcxoRutozpKu/THo0PN2yLgYi+hgLq2nHILlvRN6hvvpYCbMMq3PskwpXgK9Hc1cS9HFLZepmxuo5hf5rfJ24BlBxsiEc0PZjiqk+YD9AWeeiqQ945vHeOgX32Beabbz8dpa8Vpq8T1y25D00Inyn4QhC4C7Tbozg0SoRfxKgepAGu+sem/VqF/uL+um4fu0NXS3G2np1wEk2GEn1Jkmy01rZhmZyIPoTlm29XbrnndWbhcdrWITW+MwTfl2CWsM3eqgjmxOUtwkJJvxCBEAIcsvQZB8l9PHvf2fqjtM2Csbab8dbx/W0FTOc++0LyzReQSJnB3+XTHyFZ+c4QfOG5oTG+02IAXwKs9tdQKmPrJ61F0bg41l/VPafjCsBHAD/F4XoOpWIuAQ8v+goM57Ovyf1yVgUrwVfAfYijc+paKGUZnyH4wq2rdb1Gv1EbuuKj0w36ZExcqugoBxaitzDeAv4HpUootZTIKKRP0Tewzz5b0eeDbz6fBcpUa71Gu5OlFH2HBd/3luI5/AGlrivU9RzG6vcUUMp5ipAMSeV9+/CHa5gY4H+J/01aAPsSfQ0rw85nXxcD6xxh+ebzUegttNY5zAbiz/DXwgeYk9fbgARfW9aOT7r3Kf7WMEthobh1uULz2NPk8pg7um/T/m3jLIeHnJibgxU+WvCV9Lk8ASy8c/2AJElKrbWto8i4IxHWpHO+aNEnAnkKs1l9Jp1WaCctywsQfLuJUY6xHCww/txiKLWGOYTj+0GPJZTKHfuhI2Hjy+TYZR09JpzWAP70+L3sTgBnMumk6HNIDjv3Ldda61kHG/IXlp97uARfd2Idmu9dU/QbPNs11QUIvv02skySJBvN23sWf0uZ+C0xTCQFm4EjRmCnxAnpqR0XUMrWY8ew4k+pBYD4El2/+Cb6cG6nKgNsaL75uhQY8xcC7/oC6rHvwr3rcGRrrXUxugmL8YeXAcjk4EQM/6x/S4o+Qo6ykP544nk6d2EX7yR6EEVfl/Tss29h+TlvfPN1IPKivWuCCyOA0HAuZqs5xuw/zvjeKmXpN5bryouyV2qBui5ACPn3xM1Y0X4GkuLvUGqOul5eyit62+OzbNV0a599sow5et98WutIa51rrbcAfsGcVLq5RMGHsE6Adsm11nr8HVVdb1DXa9T1DMAd/NgsHoEQcmrCdhdQij/K1hKKvo4p4N5n38KBCPVJ7MVa643Mom4vVOS9pBpJPn60+M54TvPaDSa5uHv5gGFj+s7Z7Ah5pa2GJfy+ioWSoq8revLZZ6vWg/LNJ+5TNjB7w4Za4noC8A3AH+zROucuSZKFlG8TJrjE0+d1XaKuIxF/jwOk4JpVlhAr4fce4azG5Jfg0Plt74VqP5g1Ut2yt+2q43QMLfamWusC5hj8EGKvhvGjdgdgliTJEu6Da1+i4NvVx3ULEXMZy7zHxd8MQ4R3O+SrjBDyso1WMK7AQvDHOYE5SDZq3vX5MMc++5oMfN6LPrF0lujHZ14tYq6Un1VAltDNSAQfkiTZyunzppugx3ma135gWUOpStp1X1sephzRCbFqn1sYl0y5TGx9tpTfQKlI9iVS9HVEDjc++xaWn/PeN58jwfewE3QilDYi7raB1+EQhc4TgOjQqWOZGP2A/YGk3Qw1xyUfMDA+wiK0i2nchhlHc0IatdESQASlYhijjq/ib4kAHP6PUfQBlu5bRuib71zBt3NHU4qwq9jj+C/4XtT7TUPxMj6nzc0HlapHdxEUfcRnpg7vXZ3ZTnOY/XNzEVgL+HUo8QZKTcVCOTr63tMHsbLZnryLLT+3aCiGvEVrnZ0h+H4A+CNJkmmSJHGSJDkFX3CCb3foKW5x/8s6zXvcmnDPqkYG4tGTdMwdtrFtR/epUNcx6noKc0DwHv4c+ojGWkHfDfTcHHam3SutdXRqf9mYfPPJYZSPLb76AGBJgee3HBHBZ1X/kiQpglnmVSpzNMhULZ2mZvA/ji8ZJxu4OXQXjbrUjLPzQvqTBYwhZ4HhLIARRhC8wSfRV0jHbPNCY5xeX180FJs+k7X4zjc5VUtGIvhe1P0N/F/mncOn/Tlmmdf2wBghxJ7HHtqvDwJwPtYX+HaIh3bss89W8Hjtm08slk0Hzk8UfEHQRvCds8z7VazGl0zFakdI52x6nsAVqOsYZg/tHfpbPp9R9HVPbvm5oz77Ruabr+ng/uOiN+0HxDlbCpIkKdAu+kR+4cVO0UeGoGQROBF/W4nI05f4G+0qwWCiT6xuti/umCBajmgQjByLRBIuMZpvcFZa6zWLzhlbFgHpkWnDz89HK2qfxd8XVovmvBv4+TnO89m3sHzOQwCOa5ss7d6PwL8esZ8gbUTAfW341c/itLkKNOvnDFwzx2mrWDPJAVyNM009Okx7y7Hxjxl1KixtnCMbp+wbmPCkZGSiD3jhs29MvvlauNkYcrYVsdkMIvwyrfUCzfd95gh3U/LkDH9Zc9YaMiLRh4ZtwZXoK4+MCZ97eM4h4ZeL6ORpfUuG3NN3rs++2PJ73vvmQ3OrxGbAtC7YbAYjxuUt8zafZCg1hevwhSMO00Q8FX3NJjKqx/xVA5d5zmoXiOhr+MKutNYR0PikazHCpdBBGpmUu2KzGXSS1EbAfXZ8mtdlfYxbfGfp+FU8sjaSI5OB4UWfiXThpt4fzt92kHxyAhas6Ctgb72IWwwEo5sFDChi12wyg7/7DP6d5nVZH29k+cYOY+VzLfoq1kRyggdH9406/pyv9X4+4ndI0dfSZ5+t6PPaN19bhgi1Jc/kvgk/iFt8x+Uyr+s2VlhZL4zgK+HeiSstC2QIcXQjdfzVcdJZO+wnv1dQyn6MazIptGdD0eeW3PJzE5ioFWPxzRfSTKgA8QJZ5m3jrsDVMq9rC8AEQAml4hMd/1zEmGJbIAPjclKwtBBA173mq6tYvP+kyQQ1dvD8aqyV0wvR19BnXxNr01hF36LPh2mtc3Avn2/Cbw0T3s3VBMse0+nXjrM8AfAdSm2gVA6l1ntXBeBXT3X00fG+LRI6JoyYKz4ftXobK2Dm6Lk/Xqn3XS+H3lpZ8MxE0MUK1Ggndm89SkvXg1EIvvl2NE3na6HpuhZ8bRtVBOKSNjNcV8u8ZU95vpL6+Hnv6nNCkrHaESuR5I5fMvGJ9q61jCOu2kIxQPsvJPbuYYFr8uzCR1895ondmEVfHspLaCFOJ67zp7Weaq1LcB+fz/Wmgj/LvJcghp5A9xDEj/HnFsDPvesz3O1lfURdv5afwsFzJwD+hFLVC8t+IQL3c6DvjqJvT/h0ZSIOwTffS5rm/UascC4EXyyN6hrEd+G3hg/LvGZm/DDy4s4c7V8iY8Ms8Y7FtU9ukd/KYX4V/mnZv3EocEc/sXsbXOWyI0TffG1E6q3WuujqNK/WOtZab2BM5l00KorGfojbdKQOlnnXIy7jJ3Bpl1xee3hEXdvmYwxiafQTO99EX4HmEQfGUvmKlt+7AVBprbM2S3Za67l8dyf2rrrM1M6hNnGHLPN+a/HVbpd5jZPUsVr7Ylr5SMP2kCN8a9+ykWDqZvwOQeAGyzufEpMkyVZrXeC8fWRB+uZLkmSjtb5vmfcJgI8APmqtn2COm+/KYL8s5jAxGafy77aWuCfYWwILWYYu9567ABCP0YfiwFaFRQvRnqNbF0AxgL9GVrb3jk9kkvESw+y5C5Efjep9XW+hVAZ3e+36eFej562HacoH/v7QA/e5TETM7fY/7G/2/Sr/9/EMwXePZstcO0H6J4wl8SM6tiaSv52ct+m0ul3mNXv7Po2oaGu4j/BBxoqxfn8LtN7HLfK7hnv3TS74dCnh3LwTfQ199o1K9J3hdLcv7pMkuYjZUKD1p+0A0/UybyaTgzEIvojLuuTM9rBEWNsennDedoYYYS3z3kufdRG89TRdbYVbSL75jg3ca087iG97gq8E8ZV1y0lTt5Oluo4DF373FHykQxYIwwL2JPW+OqPtVwhnqfRe+qqLYWyiL2cH4aQTuEuSZLn3fxWIr5OGLXw5zWs60y+BFeETzFIPD26QLtvCFsZZvc8ToRrA7CzB95zfAsAd/Lb4fbk0weet6Gvpsy9E33ynBu4Iw1v8HgDMkyTJD6TvB4iv9aeED8u8pvNfA/iAME4x/gAwv6SlHtKz8DMi45OHYugb6nre6UTHnF6O4J+F8xHAh0s4qRuM6BPyhp8P0TffSeGXJEkEYyl5GqBR3CVJEp1YLr/IBhMQ65b1Ju88JWaD9Hygumw7ufmAul4wri7pQfxl0h7uPan772XfoYu8VqhrX9r+k6RjfimHNkITfUXDSpKP8QXJHr++Ooid2Ju9tO4dSFcFY74nnk4a4FNsXmPlWAOYScc7tOXvEcYa+h/UdXTJgwAZRPhtxOr3n4HE326iE3WynPt6fods+zuxN0Ndry9928Y7mHBbtsuIVV8JE599GYx5+DW2Pft867XMxNoWy2Acy9WV25Ma5mBGLkKuSbpyrfVWBHeTCB6PUoZH32eD8t0MOEP2XfgVWutvaO6HL9JaT51Yzk2HuwawhlJzmP2rEfqJ3vIgdb1wPNBtHdaPjcfP7qN9VI4+O5z4A2IotZS2sGsPLsKM7fr6bBCL9j/b/i6fC7hx4fW419YLzjKeefP792+WQoBI6LVIZk8RjONjZdERb6UzrACUXQzsWuupCNHFkcH7ae+ZjcUluRCMCJxLnd5daCgIa6nju3q+AVD1Ys0gxE1bmEv/PrMUSLtJ9e4qpQ1sPc3rVPIY7bV7m/Fsf2zZH9cqbtM4zv8PADGqa+vMGq+/AAAAAElFTkSuQmCC"/>
</defs>
</svg>
</template>
<script setup>
import {onMounted,onBeforeUnmount,ref} from 'vue';
import {playBrandIntro} from '../brandIntroPlayback.mjs';
import {beginEntryTimeline,ENTRY_ANIMATION_MS} from '../entryTimeline.mjs';
const props=defineProps({duration:{type:Number,default:ENTRY_ANIMATION_MS}});
const emit=defineEmits(['ready','complete','error']);
const art=ref(null);
let stop=()=>{};
onMounted(()=>{
  try{
    // Async-view and SSO handoffs share a clock so a cold download cannot replay the intro.
    const start=beginEntryTimeline();
    stop=playBrandIntro(art.value,{duration:props.duration,elapsed:Date.now()-start,reducedMotion:window.matchMedia('(prefers-reduced-motion: reduce)').matches,onReady:()=>emit('ready'),onComplete:()=>emit('complete')});
  }catch{emit('error');}
});
onBeforeUnmount(()=>stop());
</script>
<style>
@keyframes kf_______________________1_transform_0 {
  0% {
    transform: translateX(380px) translateY(312px) translateX(-342px) translate(48px, 48px) scaleX(0.22) scaleY(4.9) translate(-48px, -48px);
  }
  1.67% {
    transform: translateX(380px) translateY(312px) translateX(-340.569px) translate(48px, 48px) scaleX(0.226) scaleY(4.88) translate(-48px, -48px);
  }
  3.33% {
    transform: translateX(380px) translateY(312px) translateX(-336.118px) translate(48px, 48px) scaleX(0.244) scaleY(4.819) translate(-48px, -48px);
  }
  5% {
    transform: translateX(380px) translateY(312px) translateX(-328.458px) translate(48px, 48px) scaleX(0.275) scaleY(4.713) translate(-48px, -48px);
  }
  6.67% {
    transform: translateX(380px) translateY(312px) translateX(-317.883px) translate(48px, 48px) scaleX(0.318) scaleY(4.568) translate(-48px, -48px);
  }
  8.33% {
    transform: translateX(380px) translateY(312px) translateX(-305.397px) translate(48px, 48px) scaleX(0.366) scaleY(4.395) translate(-48px, -48px);
  }
  10% {
    transform: translateX(380px) translateY(312px) translateX(-292.399px) translate(48px, 48px) scaleX(0.414) scaleY(4.216) translate(-48px, -48px);
  }
  11.67% {
    transform: translateX(380px) translateY(312px) translateX(-280.674px) translate(48px, 48px) scaleX(0.454) scaleY(4.055) translate(-48px, -48px);
  }
  13.33% {
    transform: translateX(380px) translateY(312px) translateX(-271.541px) translate(48px, 48px) scaleX(0.482) scaleY(3.929) translate(-48px, -48px);
  }
  15% {
    transform: translateX(380px) translateY(312px) translateX(-265.464px) translate(48px, 48px) scaleX(0.497) scaleY(3.845) translate(-48px, -48px);
  }
  16.25% {
    transform: translateX(380px) translateY(312px) translateX(-262.994px) translate(48px, 48px) scaleX(0.5) scaleY(3.811) translate(-48px, -48px);
  }
  16.67% {
    transform: translateX(380px) translateY(312px) translateX(-262.546px) translate(48px, 48px) scaleX(0.5) scaleY(3.805) translate(-48px, -48px);
  }
  17.5% {
    transform: translateX(380px) translateY(312px) translateX(-262.2px) translate(48px, 48px) scaleX(0.502) scaleY(3.8) translate(-48px, -48px);
  }
  18.33% {
    transform: translateX(380px) translateY(312px) translateX(-261.621px) translate(48px, 48px) scaleX(0.506) scaleY(3.794) translate(-48px, -48px);
  }
  20% {
    transform: translateX(380px) translateY(312px) translateX(-256.787px) translate(48px, 48px) scaleX(0.52) scaleY(3.746) translate(-48px, -48px);
  }
  21.67% {
    transform: translateX(380px) translateY(312px) translateX(-246.756px) translate(48px, 48px) scaleX(0.544) scaleY(3.645) translate(-48px, -48px);
  }
  23.33% {
    transform: translateX(380px) translateY(312px) translateX(-231.445px) translate(48px, 48px) scaleX(0.575) scaleY(3.492) translate(-48px, -48px);
  }
  25% {
    transform: translateX(380px) translateY(312px) translateX(-210.809px) translate(48px, 48px) scaleX(0.616) scaleY(3.285) translate(-48px, -48px);
  }
  26.67% {
    transform: translateX(380px) translateY(312px) translateX(-185.584px) translate(48px, 48px) scaleX(0.664) scaleY(3.029) translate(-48px, -48px);
  }
  28.33% {
    transform: translateX(380px) translateY(312px) translateX(-157.261px) translate(48px, 48px) scaleX(0.716) scaleY(2.738) translate(-48px, -48px);
  }
  30% {
    transform: translateX(380px) translateY(312px) translateX(-127.404px) translate(48px, 48px) scaleX(0.77) scaleY(2.425) translate(-48px, -48px);
  }
  31.67% {
    transform: translateX(380px) translateY(312px) translateX(-98.375px) translate(48px, 48px) scaleX(0.824) scaleY(2.112) translate(-48px, -48px);
  }
  33.33% {
    transform: translateX(380px) translateY(312px) translateX(-72.343px) translate(48px, 48px) scaleX(0.873) scaleY(1.821) translate(-48px, -48px);
  }
  35% {
    transform: translateX(380px) translateY(312px) translateX(-50.466px) translate(48px, 48px) scaleX(0.915) scaleY(1.565) translate(-48px, -48px);
  }
  36.67% {
    transform: translateX(380px) translateY(312px) translateX(-33.728px) translate(48px, 48px) scaleX(0.949) scaleY(1.358) translate(-48px, -48px);
  }
  38.33% {
    transform: translateX(380px) translateY(312px) translateX(-22.435px) translate(48px, 48px) scaleX(0.975) scaleY(1.205) translate(-48px, -48px);
  }
  40% {
    transform: translateX(380px) translateY(312px) translateX(-16.324px) translate(48px, 48px) scaleX(0.991) scaleY(1.104) translate(-48px, -48px);
  }
  41.25% {
    transform: translateX(380px) translateY(312px) translateX(-15px) translate(48px, 48px) scaleX(0.998) scaleY(1.063) translate(-48px, -48px);
  }
  41.67% {
    transform: translateX(380px) translateY(312px) translateX(-14.977px) translate(48px, 48px) scaleX(0.999) scaleY(1.056) translate(-48px, -48px);
  }
  42.5% {
    transform: translateX(380px) translateY(312px) translateX(-14.796px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  43.33% {
    transform: translateX(380px) translateY(312px) translateX(-14.423px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  45% {
    transform: translateX(380px) translateY(312px) translateX(-13.063px) translate(48px, 48px) scaleX(1) scaleY(1.047) translate(-48px, -48px);
  }
  46.67% {
    transform: translateX(380px) translateY(312px) translateX(-10.918px) translate(48px, 48px) scaleX(1) scaleY(1.04) translate(-48px, -48px);
  }
  48.33% {
    transform: translateX(380px) translateY(312px) translateX(-8.223px) translate(48px, 48px) scaleX(1) scaleY(1.031) translate(-48px, -48px);
  }
  50% {
    transform: translateX(380px) translateY(312px) translateX(-5.382px) translate(48px, 48px) scaleX(1) scaleY(1.021) translate(-48px, -48px);
  }
  51.67% {
    transform: translateX(380px) translateY(312px) translateX(-2.913px) translate(48px, 48px) scaleX(1) scaleY(1.012) translate(-48px, -48px);
  }
  53.33% {
    transform: translateX(380px) translateY(312px) translateX(-1.159px) translate(48px, 48px) scaleX(1) scaleY(1.005) translate(-48px, -48px);
  }
  55% {
    transform: translateX(380px) translateY(312px) translateX(-0.204px) translate(48px, 48px) scaleX(1) scaleY(1.001) translate(-48px, -48px);
  }
  56.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  56.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  57.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  58.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  60% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  61.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  63.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  65% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  66.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  68.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  70% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  71.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  73.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  75% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  76.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  78.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  80% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  81.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  83.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  85% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  86.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  88.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  90% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  91.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  93.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  95% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  96.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  98.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  100% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
}
@keyframes kf_______________________1_opacity_0 {
  0% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  6.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.48;
  }
  22.5% {
    animation-timing-function: ease-in-out;
    opacity: 0.7;
  }
  46.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.58;
  }
  62.5% {
    animation-timing-function: linear;
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#______________________1 {
  transform-origin: 0 0;
  animation:
    kf_______________________1_transform_0 4s linear 1 forwards,
    kf_______________________1_opacity_0 4s linear 1 forwards;
}
@keyframes kf_______________________2_transform_0 {
  0% {
    transform: translateX(380px) translateY(312px) translateX(-228px) translate(48px, 48px) scaleX(0.22) scaleY(4.9) translate(-48px, -48px);
  }
  1.67% {
    transform: translateX(380px) translateY(312px) translateX(-227.046px) translate(48px, 48px) scaleX(0.226) scaleY(4.88) translate(-48px, -48px);
  }
  3.33% {
    transform: translateX(380px) translateY(312px) translateX(-224.079px) translate(48px, 48px) scaleX(0.244) scaleY(4.819) translate(-48px, -48px);
  }
  5% {
    transform: translateX(380px) translateY(312px) translateX(-218.972px) translate(48px, 48px) scaleX(0.275) scaleY(4.713) translate(-48px, -48px);
  }
  6.67% {
    transform: translateX(380px) translateY(312px) translateX(-211.922px) translate(48px, 48px) scaleX(0.318) scaleY(4.568) translate(-48px, -48px);
  }
  8.33% {
    transform: translateX(380px) translateY(312px) translateX(-203.598px) translate(48px, 48px) scaleX(0.366) scaleY(4.395) translate(-48px, -48px);
  }
  10% {
    transform: translateX(380px) translateY(312px) translateX(-194.933px) translate(48px, 48px) scaleX(0.414) scaleY(4.216) translate(-48px, -48px);
  }
  11.67% {
    transform: translateX(380px) translateY(312px) translateX(-187.116px) translate(48px, 48px) scaleX(0.454) scaleY(4.055) translate(-48px, -48px);
  }
  13.33% {
    transform: translateX(380px) translateY(312px) translateX(-181.027px) translate(48px, 48px) scaleX(0.482) scaleY(3.929) translate(-48px, -48px);
  }
  15% {
    transform: translateX(380px) translateY(312px) translateX(-176.976px) translate(48px, 48px) scaleX(0.497) scaleY(3.845) translate(-48px, -48px);
  }
  16.25% {
    transform: translateX(380px) translateY(312px) translateX(-175.329px) translate(48px, 48px) scaleX(0.5) scaleY(3.811) translate(-48px, -48px);
  }
  16.67% {
    transform: translateX(380px) translateY(312px) translateX(-175.031px) translate(48px, 48px) scaleX(0.5) scaleY(3.805) translate(-48px, -48px);
  }
  17.5% {
    transform: translateX(380px) translateY(312px) translateX(-174.8px) translate(48px, 48px) scaleX(0.502) scaleY(3.8) translate(-48px, -48px);
  }
  18.33% {
    transform: translateX(380px) translateY(312px) translateX(-174.414px) translate(48px, 48px) scaleX(0.506) scaleY(3.794) translate(-48px, -48px);
  }
  20% {
    transform: translateX(380px) translateY(312px) translateX(-171.191px) translate(48px, 48px) scaleX(0.52) scaleY(3.746) translate(-48px, -48px);
  }
  21.67% {
    transform: translateX(380px) translateY(312px) translateX(-164.504px) translate(48px, 48px) scaleX(0.544) scaleY(3.645) translate(-48px, -48px);
  }
  23.33% {
    transform: translateX(380px) translateY(312px) translateX(-154.297px) translate(48px, 48px) scaleX(0.575) scaleY(3.492) translate(-48px, -48px);
  }
  25% {
    transform: translateX(380px) translateY(312px) translateX(-140.539px) translate(48px, 48px) scaleX(0.616) scaleY(3.285) translate(-48px, -48px);
  }
  26.67% {
    transform: translateX(380px) translateY(312px) translateX(-123.722px) translate(48px, 48px) scaleX(0.664) scaleY(3.029) translate(-48px, -48px);
  }
  28.33% {
    transform: translateX(380px) translateY(312px) translateX(-104.841px) translate(48px, 48px) scaleX(0.716) scaleY(2.738) translate(-48px, -48px);
  }
  30% {
    transform: translateX(380px) translateY(312px) translateX(-84.936px) translate(48px, 48px) scaleX(0.77) scaleY(2.425) translate(-48px, -48px);
  }
  31.67% {
    transform: translateX(380px) translateY(312px) translateX(-65.583px) translate(48px, 48px) scaleX(0.824) scaleY(2.112) translate(-48px, -48px);
  }
  33.33% {
    transform: translateX(380px) translateY(312px) translateX(-48.229px) translate(48px, 48px) scaleX(0.873) scaleY(1.821) translate(-48px, -48px);
  }
  35% {
    transform: translateX(380px) translateY(312px) translateX(-33.644px) translate(48px, 48px) scaleX(0.915) scaleY(1.565) translate(-48px, -48px);
  }
  36.67% {
    transform: translateX(380px) translateY(312px) translateX(-22.486px) translate(48px, 48px) scaleX(0.949) scaleY(1.358) translate(-48px, -48px);
  }
  38.33% {
    transform: translateX(380px) translateY(312px) translateX(-14.957px) translate(48px, 48px) scaleX(0.975) scaleY(1.205) translate(-48px, -48px);
  }
  40% {
    transform: translateX(380px) translateY(312px) translateX(-10.883px) translate(48px, 48px) scaleX(0.991) scaleY(1.104) translate(-48px, -48px);
  }
  41.25% {
    transform: translateX(380px) translateY(312px) translateX(-10px) translate(48px, 48px) scaleX(0.998) scaleY(1.063) translate(-48px, -48px);
  }
  41.67% {
    transform: translateX(380px) translateY(312px) translateX(-9.985px) translate(48px, 48px) scaleX(0.999) scaleY(1.056) translate(-48px, -48px);
  }
  42.5% {
    transform: translateX(380px) translateY(312px) translateX(-9.864px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  43.33% {
    transform: translateX(380px) translateY(312px) translateX(-9.615px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  45% {
    transform: translateX(380px) translateY(312px) translateX(-8.708px) translate(48px, 48px) scaleX(1) scaleY(1.047) translate(-48px, -48px);
  }
  46.67% {
    transform: translateX(380px) translateY(312px) translateX(-7.279px) translate(48px, 48px) scaleX(1) scaleY(1.04) translate(-48px, -48px);
  }
  48.33% {
    transform: translateX(380px) translateY(312px) translateX(-5.482px) translate(48px, 48px) scaleX(1) scaleY(1.031) translate(-48px, -48px);
  }
  50% {
    transform: translateX(380px) translateY(312px) translateX(-3.588px) translate(48px, 48px) scaleX(1) scaleY(1.021) translate(-48px, -48px);
  }
  51.67% {
    transform: translateX(380px) translateY(312px) translateX(-1.942px) translate(48px, 48px) scaleX(1) scaleY(1.012) translate(-48px, -48px);
  }
  53.33% {
    transform: translateX(380px) translateY(312px) translateX(-0.772px) translate(48px, 48px) scaleX(1) scaleY(1.005) translate(-48px, -48px);
  }
  55% {
    transform: translateX(380px) translateY(312px) translateX(-0.136px) translate(48px, 48px) scaleX(1) scaleY(1.001) translate(-48px, -48px);
  }
  56.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  56.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  57.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  58.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  60% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  61.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  63.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  65% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  66.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  68.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  70% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  71.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  73.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  75% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  76.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  78.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  80% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  81.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  83.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  85% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  86.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  88.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  90% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  91.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  93.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  95% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  96.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  98.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  100% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
}
@keyframes kf_______________________2_opacity_0 {
  0% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  6.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.48;
  }
  22.5% {
    animation-timing-function: ease-in-out;
    opacity: 0.7;
  }
  46.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.58;
  }
  62.5% {
    animation-timing-function: linear;
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#______________________2 {
  transform-origin: 0 0;
  animation:
    kf_______________________2_transform_0 4s linear 1 forwards,
    kf_______________________2_opacity_0 4s linear 1 forwards;
}
@keyframes kf_______________________3_transform_0 {
  0% {
    transform: translateX(380px) translateY(312px) translateX(-114px) translate(48px, 48px) scaleX(0.22) scaleY(4.9) translate(-48px, -48px);
  }
  1.67% {
    transform: translateX(380px) translateY(312px) translateX(-113.523px) translate(48px, 48px) scaleX(0.226) scaleY(4.88) translate(-48px, -48px);
  }
  3.33% {
    transform: translateX(380px) translateY(312px) translateX(-112.039px) translate(48px, 48px) scaleX(0.244) scaleY(4.819) translate(-48px, -48px);
  }
  5% {
    transform: translateX(380px) translateY(312px) translateX(-109.486px) translate(48px, 48px) scaleX(0.275) scaleY(4.713) translate(-48px, -48px);
  }
  6.67% {
    transform: translateX(380px) translateY(312px) translateX(-105.961px) translate(48px, 48px) scaleX(0.318) scaleY(4.568) translate(-48px, -48px);
  }
  8.33% {
    transform: translateX(380px) translateY(312px) translateX(-101.799px) translate(48px, 48px) scaleX(0.366) scaleY(4.395) translate(-48px, -48px);
  }
  10% {
    transform: translateX(380px) translateY(312px) translateX(-97.466px) translate(48px, 48px) scaleX(0.414) scaleY(4.216) translate(-48px, -48px);
  }
  11.67% {
    transform: translateX(380px) translateY(312px) translateX(-93.558px) translate(48px, 48px) scaleX(0.454) scaleY(4.055) translate(-48px, -48px);
  }
  13.33% {
    transform: translateX(380px) translateY(312px) translateX(-90.514px) translate(48px, 48px) scaleX(0.482) scaleY(3.929) translate(-48px, -48px);
  }
  15% {
    transform: translateX(380px) translateY(312px) translateX(-88.488px) translate(48px, 48px) scaleX(0.497) scaleY(3.845) translate(-48px, -48px);
  }
  16.25% {
    transform: translateX(380px) translateY(312px) translateX(-87.665px) translate(48px, 48px) scaleX(0.5) scaleY(3.811) translate(-48px, -48px);
  }
  16.67% {
    transform: translateX(380px) translateY(312px) translateX(-87.515px) translate(48px, 48px) scaleX(0.5) scaleY(3.805) translate(-48px, -48px);
  }
  17.5% {
    transform: translateX(380px) translateY(312px) translateX(-87.4px) translate(48px, 48px) scaleX(0.502) scaleY(3.8) translate(-48px, -48px);
  }
  18.33% {
    transform: translateX(380px) translateY(312px) translateX(-87.207px) translate(48px, 48px) scaleX(0.506) scaleY(3.794) translate(-48px, -48px);
  }
  20% {
    transform: translateX(380px) translateY(312px) translateX(-85.596px) translate(48px, 48px) scaleX(0.52) scaleY(3.746) translate(-48px, -48px);
  }
  21.67% {
    transform: translateX(380px) translateY(312px) translateX(-82.252px) translate(48px, 48px) scaleX(0.544) scaleY(3.645) translate(-48px, -48px);
  }
  23.33% {
    transform: translateX(380px) translateY(312px) translateX(-77.148px) translate(48px, 48px) scaleX(0.575) scaleY(3.492) translate(-48px, -48px);
  }
  25% {
    transform: translateX(380px) translateY(312px) translateX(-70.27px) translate(48px, 48px) scaleX(0.616) scaleY(3.285) translate(-48px, -48px);
  }
  26.67% {
    transform: translateX(380px) translateY(312px) translateX(-61.861px) translate(48px, 48px) scaleX(0.664) scaleY(3.029) translate(-48px, -48px);
  }
  28.33% {
    transform: translateX(380px) translateY(312px) translateX(-52.42px) translate(48px, 48px) scaleX(0.716) scaleY(2.738) translate(-48px, -48px);
  }
  30% {
    transform: translateX(380px) translateY(312px) translateX(-42.468px) translate(48px, 48px) scaleX(0.77) scaleY(2.425) translate(-48px, -48px);
  }
  31.67% {
    transform: translateX(380px) translateY(312px) translateX(-32.792px) translate(48px, 48px) scaleX(0.824) scaleY(2.112) translate(-48px, -48px);
  }
  33.33% {
    transform: translateX(380px) translateY(312px) translateX(-24.114px) translate(48px, 48px) scaleX(0.873) scaleY(1.821) translate(-48px, -48px);
  }
  35% {
    transform: translateX(380px) translateY(312px) translateX(-16.822px) translate(48px, 48px) scaleX(0.915) scaleY(1.565) translate(-48px, -48px);
  }
  36.67% {
    transform: translateX(380px) translateY(312px) translateX(-11.243px) translate(48px, 48px) scaleX(0.949) scaleY(1.358) translate(-48px, -48px);
  }
  38.33% {
    transform: translateX(380px) translateY(312px) translateX(-7.478px) translate(48px, 48px) scaleX(0.975) scaleY(1.205) translate(-48px, -48px);
  }
  40% {
    transform: translateX(380px) translateY(312px) translateX(-5.441px) translate(48px, 48px) scaleX(0.991) scaleY(1.104) translate(-48px, -48px);
  }
  41.25% {
    transform: translateX(380px) translateY(312px) translateX(-5px) translate(48px, 48px) scaleX(0.998) scaleY(1.063) translate(-48px, -48px);
  }
  41.67% {
    transform: translateX(380px) translateY(312px) translateX(-4.992px) translate(48px, 48px) scaleX(0.999) scaleY(1.056) translate(-48px, -48px);
  }
  42.5% {
    transform: translateX(380px) translateY(312px) translateX(-4.932px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  43.33% {
    transform: translateX(380px) translateY(312px) translateX(-4.808px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  45% {
    transform: translateX(380px) translateY(312px) translateX(-4.354px) translate(48px, 48px) scaleX(1) scaleY(1.047) translate(-48px, -48px);
  }
  46.67% {
    transform: translateX(380px) translateY(312px) translateX(-3.639px) translate(48px, 48px) scaleX(1) scaleY(1.04) translate(-48px, -48px);
  }
  48.33% {
    transform: translateX(380px) translateY(312px) translateX(-2.741px) translate(48px, 48px) scaleX(1) scaleY(1.031) translate(-48px, -48px);
  }
  50% {
    transform: translateX(380px) translateY(312px) translateX(-1.794px) translate(48px, 48px) scaleX(1) scaleY(1.021) translate(-48px, -48px);
  }
  51.67% {
    transform: translateX(380px) translateY(312px) translateX(-0.971px) translate(48px, 48px) scaleX(1) scaleY(1.012) translate(-48px, -48px);
  }
  53.33% {
    transform: translateX(380px) translateY(312px) translateX(-0.386px) translate(48px, 48px) scaleX(1) scaleY(1.005) translate(-48px, -48px);
  }
  55% {
    transform: translateX(380px) translateY(312px) translateX(-0.068px) translate(48px, 48px) scaleX(1) scaleY(1.001) translate(-48px, -48px);
  }
  56.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  56.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  57.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  58.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  60% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  61.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  63.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  65% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  66.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  68.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  70% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  71.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  73.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  75% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  76.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  78.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  80% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  81.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  83.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  85% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  86.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  88.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  90% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  91.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  93.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  95% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  96.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  98.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  100% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
}
@keyframes kf_______________________3_opacity_0 {
  0% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  6.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.48;
  }
  22.5% {
    animation-timing-function: ease-in-out;
    opacity: 0.7;
  }
  46.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.58;
  }
  62.5% {
    animation-timing-function: linear;
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#______________________3 {
  transform-origin: 0 0;
  animation:
    kf_______________________3_transform_0 4s linear 1 forwards,
    kf_______________________3_opacity_0 4s linear 1 forwards;
}
@keyframes kf_______________________4_transform_0 {
  0% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.22) scaleY(4.9) translate(-48px, -48px);
  }
  1.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.226) scaleY(4.88) translate(-48px, -48px);
  }
  3.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.244) scaleY(4.819) translate(-48px, -48px);
  }
  5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.275) scaleY(4.713) translate(-48px, -48px);
  }
  6.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.318) scaleY(4.568) translate(-48px, -48px);
  }
  8.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.366) scaleY(4.395) translate(-48px, -48px);
  }
  10% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.414) scaleY(4.216) translate(-48px, -48px);
  }
  11.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.454) scaleY(4.055) translate(-48px, -48px);
  }
  13.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.482) scaleY(3.929) translate(-48px, -48px);
  }
  15% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.497) scaleY(3.845) translate(-48px, -48px);
  }
  16.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.5) scaleY(3.811) translate(-48px, -48px);
  }
  16.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.5) scaleY(3.805) translate(-48px, -48px);
  }
  17.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.502) scaleY(3.8) translate(-48px, -48px);
  }
  18.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.506) scaleY(3.794) translate(-48px, -48px);
  }
  20% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.52) scaleY(3.746) translate(-48px, -48px);
  }
  21.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.544) scaleY(3.645) translate(-48px, -48px);
  }
  23.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.575) scaleY(3.492) translate(-48px, -48px);
  }
  25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.616) scaleY(3.285) translate(-48px, -48px);
  }
  26.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.664) scaleY(3.029) translate(-48px, -48px);
  }
  28.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.716) scaleY(2.738) translate(-48px, -48px);
  }
  30% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.77) scaleY(2.425) translate(-48px, -48px);
  }
  31.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.824) scaleY(2.112) translate(-48px, -48px);
  }
  33.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.873) scaleY(1.821) translate(-48px, -48px);
  }
  35% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.915) scaleY(1.565) translate(-48px, -48px);
  }
  36.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.949) scaleY(1.358) translate(-48px, -48px);
  }
  38.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.975) scaleY(1.205) translate(-48px, -48px);
  }
  40% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.991) scaleY(1.104) translate(-48px, -48px);
  }
  41.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.998) scaleY(1.063) translate(-48px, -48px);
  }
  41.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(0.999) scaleY(1.056) translate(-48px, -48px);
  }
  42.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  43.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  45% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.047) translate(-48px, -48px);
  }
  46.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.04) translate(-48px, -48px);
  }
  48.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.031) translate(-48px, -48px);
  }
  50% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.021) translate(-48px, -48px);
  }
  51.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.012) translate(-48px, -48px);
  }
  53.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.005) translate(-48px, -48px);
  }
  55% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1.001) translate(-48px, -48px);
  }
  56.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  56.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  57.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  58.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  60% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  61.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  63.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  65% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  66.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  68.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  70% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  71.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  73.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  75% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  76.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  78.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  80% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  81.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  83.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  85% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  86.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  88.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  90% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  91.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  93.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  95% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  96.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  98.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  100% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
}
@keyframes kf_______________________4_opacity_0 {
  0% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  6.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.48;
  }
  22.5% {
    animation-timing-function: ease-in-out;
    opacity: 0.7;
  }
  46.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.58;
  }
  62.5% {
    animation-timing-function: linear;
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#______________________4 {
  transform-origin: 0 0;
  animation:
    kf_______________________4_transform_0 4s linear 1 forwards,
    kf_______________________4_opacity_0 4s linear 1 forwards;
}
@keyframes kf_______________________5_transform_0 {
  0% {
    transform: translateX(380px) translateY(312px) translateX(114px) translate(48px, 48px) scaleX(0.22) scaleY(4.9) translate(-48px, -48px);
  }
  1.67% {
    transform: translateX(380px) translateY(312px) translateX(113.523px) translate(48px, 48px) scaleX(0.226) scaleY(4.88) translate(-48px, -48px);
  }
  3.33% {
    transform: translateX(380px) translateY(312px) translateX(112.039px) translate(48px, 48px) scaleX(0.244) scaleY(4.819) translate(-48px, -48px);
  }
  5% {
    transform: translateX(380px) translateY(312px) translateX(109.486px) translate(48px, 48px) scaleX(0.275) scaleY(4.713) translate(-48px, -48px);
  }
  6.67% {
    transform: translateX(380px) translateY(312px) translateX(105.961px) translate(48px, 48px) scaleX(0.318) scaleY(4.568) translate(-48px, -48px);
  }
  8.33% {
    transform: translateX(380px) translateY(312px) translateX(101.799px) translate(48px, 48px) scaleX(0.366) scaleY(4.395) translate(-48px, -48px);
  }
  10% {
    transform: translateX(380px) translateY(312px) translateX(97.466px) translate(48px, 48px) scaleX(0.414) scaleY(4.216) translate(-48px, -48px);
  }
  11.67% {
    transform: translateX(380px) translateY(312px) translateX(93.558px) translate(48px, 48px) scaleX(0.454) scaleY(4.055) translate(-48px, -48px);
  }
  13.33% {
    transform: translateX(380px) translateY(312px) translateX(90.514px) translate(48px, 48px) scaleX(0.482) scaleY(3.929) translate(-48px, -48px);
  }
  15% {
    transform: translateX(380px) translateY(312px) translateX(88.488px) translate(48px, 48px) scaleX(0.497) scaleY(3.845) translate(-48px, -48px);
  }
  16.25% {
    transform: translateX(380px) translateY(312px) translateX(87.665px) translate(48px, 48px) scaleX(0.5) scaleY(3.811) translate(-48px, -48px);
  }
  16.67% {
    transform: translateX(380px) translateY(312px) translateX(87.515px) translate(48px, 48px) scaleX(0.5) scaleY(3.805) translate(-48px, -48px);
  }
  17.5% {
    transform: translateX(380px) translateY(312px) translateX(87.4px) translate(48px, 48px) scaleX(0.502) scaleY(3.8) translate(-48px, -48px);
  }
  18.33% {
    transform: translateX(380px) translateY(312px) translateX(87.207px) translate(48px, 48px) scaleX(0.506) scaleY(3.794) translate(-48px, -48px);
  }
  20% {
    transform: translateX(380px) translateY(312px) translateX(85.596px) translate(48px, 48px) scaleX(0.52) scaleY(3.746) translate(-48px, -48px);
  }
  21.67% {
    transform: translateX(380px) translateY(312px) translateX(82.252px) translate(48px, 48px) scaleX(0.544) scaleY(3.645) translate(-48px, -48px);
  }
  23.33% {
    transform: translateX(380px) translateY(312px) translateX(77.148px) translate(48px, 48px) scaleX(0.575) scaleY(3.492) translate(-48px, -48px);
  }
  25% {
    transform: translateX(380px) translateY(312px) translateX(70.27px) translate(48px, 48px) scaleX(0.616) scaleY(3.285) translate(-48px, -48px);
  }
  26.67% {
    transform: translateX(380px) translateY(312px) translateX(61.861px) translate(48px, 48px) scaleX(0.664) scaleY(3.029) translate(-48px, -48px);
  }
  28.33% {
    transform: translateX(380px) translateY(312px) translateX(52.42px) translate(48px, 48px) scaleX(0.716) scaleY(2.738) translate(-48px, -48px);
  }
  30% {
    transform: translateX(380px) translateY(312px) translateX(42.468px) translate(48px, 48px) scaleX(0.77) scaleY(2.425) translate(-48px, -48px);
  }
  31.67% {
    transform: translateX(380px) translateY(312px) translateX(32.792px) translate(48px, 48px) scaleX(0.824) scaleY(2.112) translate(-48px, -48px);
  }
  33.33% {
    transform: translateX(380px) translateY(312px) translateX(24.114px) translate(48px, 48px) scaleX(0.873) scaleY(1.821) translate(-48px, -48px);
  }
  35% {
    transform: translateX(380px) translateY(312px) translateX(16.822px) translate(48px, 48px) scaleX(0.915) scaleY(1.565) translate(-48px, -48px);
  }
  36.67% {
    transform: translateX(380px) translateY(312px) translateX(11.243px) translate(48px, 48px) scaleX(0.949) scaleY(1.358) translate(-48px, -48px);
  }
  38.33% {
    transform: translateX(380px) translateY(312px) translateX(7.478px) translate(48px, 48px) scaleX(0.975) scaleY(1.205) translate(-48px, -48px);
  }
  40% {
    transform: translateX(380px) translateY(312px) translateX(5.441px) translate(48px, 48px) scaleX(0.991) scaleY(1.104) translate(-48px, -48px);
  }
  41.25% {
    transform: translateX(380px) translateY(312px) translateX(5px) translate(48px, 48px) scaleX(0.998) scaleY(1.063) translate(-48px, -48px);
  }
  41.67% {
    transform: translateX(380px) translateY(312px) translateX(4.992px) translate(48px, 48px) scaleX(0.999) scaleY(1.056) translate(-48px, -48px);
  }
  42.5% {
    transform: translateX(380px) translateY(312px) translateX(4.932px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  43.33% {
    transform: translateX(380px) translateY(312px) translateX(4.808px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  45% {
    transform: translateX(380px) translateY(312px) translateX(4.354px) translate(48px, 48px) scaleX(1) scaleY(1.047) translate(-48px, -48px);
  }
  46.67% {
    transform: translateX(380px) translateY(312px) translateX(3.639px) translate(48px, 48px) scaleX(1) scaleY(1.04) translate(-48px, -48px);
  }
  48.33% {
    transform: translateX(380px) translateY(312px) translateX(2.741px) translate(48px, 48px) scaleX(1) scaleY(1.031) translate(-48px, -48px);
  }
  50% {
    transform: translateX(380px) translateY(312px) translateX(1.794px) translate(48px, 48px) scaleX(1) scaleY(1.021) translate(-48px, -48px);
  }
  51.67% {
    transform: translateX(380px) translateY(312px) translateX(0.971px) translate(48px, 48px) scaleX(1) scaleY(1.012) translate(-48px, -48px);
  }
  53.33% {
    transform: translateX(380px) translateY(312px) translateX(0.386px) translate(48px, 48px) scaleX(1) scaleY(1.005) translate(-48px, -48px);
  }
  55% {
    transform: translateX(380px) translateY(312px) translateX(0.068px) translate(48px, 48px) scaleX(1) scaleY(1.001) translate(-48px, -48px);
  }
  56.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  56.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  57.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  58.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  60% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  61.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  63.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  65% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  66.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  68.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  70% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  71.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  73.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  75% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  76.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  78.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  80% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  81.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  83.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  85% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  86.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  88.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  90% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  91.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  93.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  95% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  96.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  98.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  100% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
}
@keyframes kf_______________________5_opacity_0 {
  0% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  6.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.48;
  }
  22.5% {
    animation-timing-function: ease-in-out;
    opacity: 0.7;
  }
  46.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.58;
  }
  62.5% {
    animation-timing-function: linear;
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#______________________5 {
  transform-origin: 0 0;
  animation:
    kf_______________________5_transform_0 4s linear 1 forwards,
    kf_______________________5_opacity_0 4s linear 1 forwards;
}
@keyframes kf_______________________6_transform_0 {
  0% {
    transform: translateX(380px) translateY(312px) translateX(228px) translate(48px, 48px) scaleX(0.22) scaleY(4.9) translate(-48px, -48px);
  }
  1.67% {
    transform: translateX(380px) translateY(312px) translateX(227.046px) translate(48px, 48px) scaleX(0.226) scaleY(4.88) translate(-48px, -48px);
  }
  3.33% {
    transform: translateX(380px) translateY(312px) translateX(224.079px) translate(48px, 48px) scaleX(0.244) scaleY(4.819) translate(-48px, -48px);
  }
  5% {
    transform: translateX(380px) translateY(312px) translateX(218.972px) translate(48px, 48px) scaleX(0.275) scaleY(4.713) translate(-48px, -48px);
  }
  6.67% {
    transform: translateX(380px) translateY(312px) translateX(211.922px) translate(48px, 48px) scaleX(0.318) scaleY(4.568) translate(-48px, -48px);
  }
  8.33% {
    transform: translateX(380px) translateY(312px) translateX(203.598px) translate(48px, 48px) scaleX(0.366) scaleY(4.395) translate(-48px, -48px);
  }
  10% {
    transform: translateX(380px) translateY(312px) translateX(194.933px) translate(48px, 48px) scaleX(0.414) scaleY(4.216) translate(-48px, -48px);
  }
  11.67% {
    transform: translateX(380px) translateY(312px) translateX(187.116px) translate(48px, 48px) scaleX(0.454) scaleY(4.055) translate(-48px, -48px);
  }
  13.33% {
    transform: translateX(380px) translateY(312px) translateX(181.027px) translate(48px, 48px) scaleX(0.482) scaleY(3.929) translate(-48px, -48px);
  }
  15% {
    transform: translateX(380px) translateY(312px) translateX(176.976px) translate(48px, 48px) scaleX(0.497) scaleY(3.845) translate(-48px, -48px);
  }
  16.25% {
    transform: translateX(380px) translateY(312px) translateX(175.329px) translate(48px, 48px) scaleX(0.5) scaleY(3.811) translate(-48px, -48px);
  }
  16.67% {
    transform: translateX(380px) translateY(312px) translateX(175.031px) translate(48px, 48px) scaleX(0.5) scaleY(3.805) translate(-48px, -48px);
  }
  17.5% {
    transform: translateX(380px) translateY(312px) translateX(174.8px) translate(48px, 48px) scaleX(0.502) scaleY(3.8) translate(-48px, -48px);
  }
  18.33% {
    transform: translateX(380px) translateY(312px) translateX(174.414px) translate(48px, 48px) scaleX(0.506) scaleY(3.794) translate(-48px, -48px);
  }
  20% {
    transform: translateX(380px) translateY(312px) translateX(171.191px) translate(48px, 48px) scaleX(0.52) scaleY(3.746) translate(-48px, -48px);
  }
  21.67% {
    transform: translateX(380px) translateY(312px) translateX(164.504px) translate(48px, 48px) scaleX(0.544) scaleY(3.645) translate(-48px, -48px);
  }
  23.33% {
    transform: translateX(380px) translateY(312px) translateX(154.297px) translate(48px, 48px) scaleX(0.575) scaleY(3.492) translate(-48px, -48px);
  }
  25% {
    transform: translateX(380px) translateY(312px) translateX(140.539px) translate(48px, 48px) scaleX(0.616) scaleY(3.285) translate(-48px, -48px);
  }
  26.67% {
    transform: translateX(380px) translateY(312px) translateX(123.722px) translate(48px, 48px) scaleX(0.664) scaleY(3.029) translate(-48px, -48px);
  }
  28.33% {
    transform: translateX(380px) translateY(312px) translateX(104.841px) translate(48px, 48px) scaleX(0.716) scaleY(2.738) translate(-48px, -48px);
  }
  30% {
    transform: translateX(380px) translateY(312px) translateX(84.936px) translate(48px, 48px) scaleX(0.77) scaleY(2.425) translate(-48px, -48px);
  }
  31.67% {
    transform: translateX(380px) translateY(312px) translateX(65.583px) translate(48px, 48px) scaleX(0.824) scaleY(2.112) translate(-48px, -48px);
  }
  33.33% {
    transform: translateX(380px) translateY(312px) translateX(48.229px) translate(48px, 48px) scaleX(0.873) scaleY(1.821) translate(-48px, -48px);
  }
  35% {
    transform: translateX(380px) translateY(312px) translateX(33.644px) translate(48px, 48px) scaleX(0.915) scaleY(1.565) translate(-48px, -48px);
  }
  36.67% {
    transform: translateX(380px) translateY(312px) translateX(22.486px) translate(48px, 48px) scaleX(0.949) scaleY(1.358) translate(-48px, -48px);
  }
  38.33% {
    transform: translateX(380px) translateY(312px) translateX(14.957px) translate(48px, 48px) scaleX(0.975) scaleY(1.205) translate(-48px, -48px);
  }
  40% {
    transform: translateX(380px) translateY(312px) translateX(10.883px) translate(48px, 48px) scaleX(0.991) scaleY(1.104) translate(-48px, -48px);
  }
  41.25% {
    transform: translateX(380px) translateY(312px) translateX(10px) translate(48px, 48px) scaleX(0.998) scaleY(1.063) translate(-48px, -48px);
  }
  41.67% {
    transform: translateX(380px) translateY(312px) translateX(9.985px) translate(48px, 48px) scaleX(0.999) scaleY(1.056) translate(-48px, -48px);
  }
  42.5% {
    transform: translateX(380px) translateY(312px) translateX(9.864px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  43.33% {
    transform: translateX(380px) translateY(312px) translateX(9.615px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  45% {
    transform: translateX(380px) translateY(312px) translateX(8.708px) translate(48px, 48px) scaleX(1) scaleY(1.047) translate(-48px, -48px);
  }
  46.67% {
    transform: translateX(380px) translateY(312px) translateX(7.279px) translate(48px, 48px) scaleX(1) scaleY(1.04) translate(-48px, -48px);
  }
  48.33% {
    transform: translateX(380px) translateY(312px) translateX(5.482px) translate(48px, 48px) scaleX(1) scaleY(1.031) translate(-48px, -48px);
  }
  50% {
    transform: translateX(380px) translateY(312px) translateX(3.588px) translate(48px, 48px) scaleX(1) scaleY(1.021) translate(-48px, -48px);
  }
  51.67% {
    transform: translateX(380px) translateY(312px) translateX(1.942px) translate(48px, 48px) scaleX(1) scaleY(1.012) translate(-48px, -48px);
  }
  53.33% {
    transform: translateX(380px) translateY(312px) translateX(0.772px) translate(48px, 48px) scaleX(1) scaleY(1.005) translate(-48px, -48px);
  }
  55% {
    transform: translateX(380px) translateY(312px) translateX(0.136px) translate(48px, 48px) scaleX(1) scaleY(1.001) translate(-48px, -48px);
  }
  56.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  56.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  57.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  58.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  60% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  61.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  63.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  65% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  66.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  68.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  70% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  71.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  73.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  75% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  76.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  78.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  80% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  81.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  83.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  85% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  86.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  88.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  90% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  91.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  93.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  95% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  96.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  98.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  100% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
}
@keyframes kf_______________________6_opacity_0 {
  0% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  6.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.48;
  }
  22.5% {
    animation-timing-function: ease-in-out;
    opacity: 0.7;
  }
  46.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.58;
  }
  62.5% {
    animation-timing-function: linear;
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#______________________6 {
  transform-origin: 0 0;
  animation:
    kf_______________________6_transform_0 4s linear 1 forwards,
    kf_______________________6_opacity_0 4s linear 1 forwards;
}
@keyframes kf_______________________7_transform_0 {
  0% {
    transform: translateX(380px) translateY(312px) translateX(342px) translate(48px, 48px) scaleX(0.22) scaleY(4.9) translate(-48px, -48px);
  }
  1.67% {
    transform: translateX(380px) translateY(312px) translateX(340.569px) translate(48px, 48px) scaleX(0.226) scaleY(4.88) translate(-48px, -48px);
  }
  3.33% {
    transform: translateX(380px) translateY(312px) translateX(336.118px) translate(48px, 48px) scaleX(0.244) scaleY(4.819) translate(-48px, -48px);
  }
  5% {
    transform: translateX(380px) translateY(312px) translateX(328.458px) translate(48px, 48px) scaleX(0.275) scaleY(4.713) translate(-48px, -48px);
  }
  6.67% {
    transform: translateX(380px) translateY(312px) translateX(317.883px) translate(48px, 48px) scaleX(0.318) scaleY(4.568) translate(-48px, -48px);
  }
  8.33% {
    transform: translateX(380px) translateY(312px) translateX(305.397px) translate(48px, 48px) scaleX(0.366) scaleY(4.395) translate(-48px, -48px);
  }
  10% {
    transform: translateX(380px) translateY(312px) translateX(292.399px) translate(48px, 48px) scaleX(0.414) scaleY(4.216) translate(-48px, -48px);
  }
  11.67% {
    transform: translateX(380px) translateY(312px) translateX(280.674px) translate(48px, 48px) scaleX(0.454) scaleY(4.055) translate(-48px, -48px);
  }
  13.33% {
    transform: translateX(380px) translateY(312px) translateX(271.541px) translate(48px, 48px) scaleX(0.482) scaleY(3.929) translate(-48px, -48px);
  }
  15% {
    transform: translateX(380px) translateY(312px) translateX(265.464px) translate(48px, 48px) scaleX(0.497) scaleY(3.845) translate(-48px, -48px);
  }
  16.25% {
    transform: translateX(380px) translateY(312px) translateX(262.994px) translate(48px, 48px) scaleX(0.5) scaleY(3.811) translate(-48px, -48px);
  }
  16.67% {
    transform: translateX(380px) translateY(312px) translateX(262.546px) translate(48px, 48px) scaleX(0.5) scaleY(3.805) translate(-48px, -48px);
  }
  17.5% {
    transform: translateX(380px) translateY(312px) translateX(262.2px) translate(48px, 48px) scaleX(0.502) scaleY(3.8) translate(-48px, -48px);
  }
  18.33% {
    transform: translateX(380px) translateY(312px) translateX(261.621px) translate(48px, 48px) scaleX(0.506) scaleY(3.794) translate(-48px, -48px);
  }
  20% {
    transform: translateX(380px) translateY(312px) translateX(256.787px) translate(48px, 48px) scaleX(0.52) scaleY(3.746) translate(-48px, -48px);
  }
  21.67% {
    transform: translateX(380px) translateY(312px) translateX(246.756px) translate(48px, 48px) scaleX(0.544) scaleY(3.645) translate(-48px, -48px);
  }
  23.33% {
    transform: translateX(380px) translateY(312px) translateX(231.445px) translate(48px, 48px) scaleX(0.575) scaleY(3.492) translate(-48px, -48px);
  }
  25% {
    transform: translateX(380px) translateY(312px) translateX(210.809px) translate(48px, 48px) scaleX(0.616) scaleY(3.285) translate(-48px, -48px);
  }
  26.67% {
    transform: translateX(380px) translateY(312px) translateX(185.584px) translate(48px, 48px) scaleX(0.664) scaleY(3.029) translate(-48px, -48px);
  }
  28.33% {
    transform: translateX(380px) translateY(312px) translateX(157.261px) translate(48px, 48px) scaleX(0.716) scaleY(2.738) translate(-48px, -48px);
  }
  30% {
    transform: translateX(380px) translateY(312px) translateX(127.404px) translate(48px, 48px) scaleX(0.77) scaleY(2.425) translate(-48px, -48px);
  }
  31.67% {
    transform: translateX(380px) translateY(312px) translateX(98.375px) translate(48px, 48px) scaleX(0.824) scaleY(2.112) translate(-48px, -48px);
  }
  33.33% {
    transform: translateX(380px) translateY(312px) translateX(72.343px) translate(48px, 48px) scaleX(0.873) scaleY(1.821) translate(-48px, -48px);
  }
  35% {
    transform: translateX(380px) translateY(312px) translateX(50.466px) translate(48px, 48px) scaleX(0.915) scaleY(1.565) translate(-48px, -48px);
  }
  36.67% {
    transform: translateX(380px) translateY(312px) translateX(33.728px) translate(48px, 48px) scaleX(0.949) scaleY(1.358) translate(-48px, -48px);
  }
  38.33% {
    transform: translateX(380px) translateY(312px) translateX(22.435px) translate(48px, 48px) scaleX(0.975) scaleY(1.205) translate(-48px, -48px);
  }
  40% {
    transform: translateX(380px) translateY(312px) translateX(16.324px) translate(48px, 48px) scaleX(0.991) scaleY(1.104) translate(-48px, -48px);
  }
  41.25% {
    transform: translateX(380px) translateY(312px) translateX(15px) translate(48px, 48px) scaleX(0.998) scaleY(1.063) translate(-48px, -48px);
  }
  41.67% {
    transform: translateX(380px) translateY(312px) translateX(14.977px) translate(48px, 48px) scaleX(0.999) scaleY(1.056) translate(-48px, -48px);
  }
  42.5% {
    transform: translateX(380px) translateY(312px) translateX(14.796px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  43.33% {
    transform: translateX(380px) translateY(312px) translateX(14.423px) translate(48px, 48px) scaleX(1) scaleY(1.05) translate(-48px, -48px);
  }
  45% {
    transform: translateX(380px) translateY(312px) translateX(13.063px) translate(48px, 48px) scaleX(1) scaleY(1.047) translate(-48px, -48px);
  }
  46.67% {
    transform: translateX(380px) translateY(312px) translateX(10.918px) translate(48px, 48px) scaleX(1) scaleY(1.04) translate(-48px, -48px);
  }
  48.33% {
    transform: translateX(380px) translateY(312px) translateX(8.223px) translate(48px, 48px) scaleX(1) scaleY(1.031) translate(-48px, -48px);
  }
  50% {
    transform: translateX(380px) translateY(312px) translateX(5.382px) translate(48px, 48px) scaleX(1) scaleY(1.021) translate(-48px, -48px);
  }
  51.67% {
    transform: translateX(380px) translateY(312px) translateX(2.913px) translate(48px, 48px) scaleX(1) scaleY(1.012) translate(-48px, -48px);
  }
  53.33% {
    transform: translateX(380px) translateY(312px) translateX(1.159px) translate(48px, 48px) scaleX(1) scaleY(1.005) translate(-48px, -48px);
  }
  55% {
    transform: translateX(380px) translateY(312px) translateX(0.204px) translate(48px, 48px) scaleX(1) scaleY(1.001) translate(-48px, -48px);
  }
  56.25% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  56.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  57.5% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  58.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  60% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  61.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  63.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  65% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  66.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  68.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  70% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  71.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  73.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  75% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  76.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  78.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  80% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  81.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  83.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  85% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  86.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  88.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  90% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  91.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  93.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  95% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  96.67% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  98.33% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
  100% {
    transform: translateX(380px) translateY(312px) translateX(0px) translate(48px, 48px) scaleX(1) scaleY(1) translate(-48px, -48px);
  }
}
@keyframes kf_______________________7_opacity_0 {
  0% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  6.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.48;
  }
  22.5% {
    animation-timing-function: ease-in-out;
    opacity: 0.7;
  }
  46.25% {
    animation-timing-function: ease-in-out;
    opacity: 0.58;
  }
  62.5% {
    animation-timing-function: linear;
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#______________________7 {
  transform-origin: 0 0;
  animation:
    kf_______________________7_transform_0 4s linear 1 forwards,
    kf_______________________7_opacity_0 4s linear 1 forwards;
}
@keyframes kf_MS_________________MarkSimos________transform_0 {
  0% {
    transform: translateX(380px) translateY(312px) translate(259.5px, 48px) scaleX(1.18) scaleY(1.18) translate(-259.5px, -48px);
  }
  30% {
    animation-timing-function: ease-in-out;
    transform: translateX(380px) translateY(312px) translate(259.5px, 48px) scaleX(1.18) scaleY(1.18) translate(-259.5px, -48px);
  }
  62.5% {
    transform: translateX(380px) translateY(312px) translate(259.5px, 48px) scaleX(1) scaleY(1) translate(-259.5px, -48px);
  }
  100% {
    transform: translateX(380px) translateY(312px) translate(259.5px, 48px) scaleX(1) scaleY(1) translate(-259.5px, -48px);
  }
}
@keyframes kf_MS_________________MarkSimos________opacity_0 {
  0% {
    animation-timing-function: linear;
    opacity: 0;
  }
  30% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  47.5% {
    animation-timing-function: linear;
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
#MS_________________MarkSimos_______ {
  transform-origin: 0 0;
  animation:
    kf_MS_________________MarkSimos________transform_0 4s linear 1 forwards,
    kf_MS_________________MarkSimos________opacity_0 4s linear 1 forwards;
}
@keyframes kf_MS_2_2_transform_0 {
  0% {
    transform: translateX(126px) translateY(6.973px) translateX(30px);
  }
  32.5% {
    animation-timing-function: ease-in-out;
    transform: translateX(126px) translateY(6.973px) translateX(30px);
  }
  58.75% {
    transform: translateX(126px) translateY(6.973px) translateX(0px);
  }
  100% {
    transform: translateX(126px) translateY(6.973px) translateX(0px);
  }
}
@keyframes kf_MS_2_2_opacity_0 {
  0% {
    animation-timing-function: linear;
    opacity: 0;
  }
  33.75% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  58.75% {
    animation-timing-function: linear;
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
#MS_2_2 {
  transform-origin: 0 0;
  animation:
    kf_MS_2_2_transform_0 4s linear 1 forwards,
    kf_MS_2_2_opacity_0 4s linear 1 forwards;
}
@keyframes kf______________transform_0 {
  0% {
    transform: translateX(-100px) translateY(-32px) translateX(0px) rotate(0.209rad) scaleX(1) scaleY(1) skewX(0rad);
  }
  52.5% {
    animation-timing-function: ease-in-out;
    transform: translateX(-100px) translateY(-32px) translateX(0px) rotate(0.209rad) scaleX(1) scaleY(1) skewX(0rad);
  }
  82.5% {
    transform: translateX(-100px) translateY(-32px) translateX(760px) rotate(0.209rad) scaleX(1) scaleY(1) skewX(0rad);
  }
  100% {
    transform: translateX(-100px) translateY(-32px) translateX(760px) rotate(0.209rad) scaleX(1) scaleY(1) skewX(0rad);
  }
}
@keyframes kf______________opacity_0 {
  0% {
    animation-timing-function: linear;
    opacity: 0;
  }
  52.5% {
    animation-timing-function: ease-in-out;
    opacity: 0;
  }
  57.5% {
    animation-timing-function: linear;
    opacity: 0.65;
  }
  80% {
    animation-timing-function: ease-in-out;
    opacity: 0.65;
  }
  85% {
    animation-timing-function: linear;
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
#____________ {
  transform-origin: 0 0;
  animation:
    kf______________transform_0 4s linear 1 forwards,
    kf______________opacity_0 4s linear 1 forwards;
}
</style>
